/* eslint-disable */
import saveStoreDraft from "../../../utils/saveStoreDraft";
import useStoreFormDraft from "../../../hooks/useStoreFormDraft";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { applyStoreDraft } from "../../../redux/store/store";
import { doc } from "firebase/firestore";
import { db } from "../../../firebase";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import apicache from "../../../components/clearCach/clear";
import { fetchDate } from "../../../utils/globleFunc";
import {
  TrendingUp,
  Check,
  X,
  RefreshCw,
  Lock,
  Info,
  DollarSign,
  ShoppingBag,
  Gift,
  AlertTriangle,
  ToggleRight,
} from "lucide-react";
import { useTranslation } from "react-i18next";
export default function ActivationUpsell({ close }) {
  const account = useSelector((state) => state.AccountReducer);
  const store = useSelector((state) => state.StoreReducer);
  const dispatch = useDispatch();
  const MySwal = withReactContent(Swal);
  const [loading, setLoading] = useState(false);
  const products = useSelector((state) => state.ProductsReducer);
  const [isUpsellActive, setIsUpsellActive] = useState(false);
  const { t } = useTranslation();

  const [data, setData] = useStoreFormDraft(store);

  const [currentDate, setCurrentDate] = useState("");

  useEffect(() => {
    if (store) {

      setIsUpsellActive(Boolean(store.Upsell));
    }
  }, [store]);

  useEffect(() => {
    const fetchAndSetCurrentDate = async () => {
      const res = await fetchDate();
      setCurrentDate(res);
    };

    fetchAndSetCurrentDate();
    const interval = setInterval(() => fetchAndSetCurrentDate(), 60000);
    return () => clearInterval(interval);
  }, []);

  const showAlert = (
    icon,
    title,
    text,
    showCancelButton = false,
    confirmButtonText = t("servicePageActivation.upsell.alerts.ok")
  ) => {
    return Swal.fire({
      icon,
      title,
      text,
      confirmButtonText,
      cancelButtonText: t("servicePageActivation.upsell.alerts.annuler"),
      showCancelButton,
      confirmButtonColor: "rgb(141, 93, 167)",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: true,
      backdrop: `
        rgba(0,0,0,0.7)
      `,
      position: "center",
      customClass: {
        popup: "swal-popup-on-top",
        backdrop: "swal-backdrop-on-top",
        container: "swal-container-on-top",
      },
      willOpen: () => {
        // Ensure this alert appears on top of everything
        document.querySelector(".swal2-container").style.zIndex = "9999999999";
      },
    });
  };

  // Add this style to ensure SweetAlert appears on top
  useEffect(() => {
    // Add CSS to make sure SweetAlert appears on top of other modals
    const style = document.createElement("style");
    style.innerHTML = `
      .swal-container-on-top {
        z-index: 9999999999 !important;
      }
      .swal-backdrop-on-top {
        background: rgba(0,0,0,0.7) !important;
      }
      .swal-popup-on-top {
        position: relative;
        box-shadow: 0 0 20px rgba(0,0,0,0.2);
      }
      body.swal2-shown {
        overflow: hidden;
      }
      body.swal2-shown > [aria-hidden="true"] {
        filter: blur(3px);
      }
    `;
    document.head.appendChild(style);

    // Add a click handler to ensure modal shows on top
    const handleDocumentClick = () => {
      const swalContainer = document.querySelector(".swal2-container");
      if (swalContainer) {
        swalContainer.style.zIndex = "9999999999";
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.head.removeChild(style);
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const handleDChange = () => {
    setData({ ...data, Upsell: !data.Upsell });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if we're activating or deactivating
    const isActivating = data.Upsell;
    const isDeactivating = !data.Upsell && isUpsellActive;

    if (isDeactivating) {
      // If deactivating, confirm with user
      const result = await showAlert(
        "warning",
        t("servicePageActivation.upsell.alerts.confirmDeactivation.title"),
        t("servicePageActivation.upsell.alerts.confirmDeactivation.text"),
        true,
        t("servicePageActivation.upsell.alerts.confirmDeactivation.confirmButton")
      );

      // If user cancels the confirmation, stop the process
      if (!result.isConfirmed) {
        // Reset toggle to previous state
        setData({ ...data, Upsell: true });
        return;
      }
    }

    try {
      setLoading(true);
      await apicache(account, products);

      await saveStoreDraft(doc(db, "store", data.id), store, data);
      dispatch(applyStoreDraft(store, data));

      setLoading(false);
      setIsUpsellActive(isActivating);

      if (isDeactivating) {
        await showAlert("success", t("servicePageActivation.upsell.alerts.success.deactivated"));
      } else if (isActivating) {
        await showAlert("success", t("servicePageActivation.upsell.alerts.success.activated"));
      } else {
        await showAlert("success", t("servicePageActivation.upsell.alerts.success.saved"));
      }
      close();
    } catch (error) {
      setLoading(false);

      if (isDeactivating) {
        await showAlert(
          "error",
          t("servicePageActivation.upsell.alerts.error.deactivation.title"),
          t("servicePageActivation.upsell.alerts.error.deactivation.text")
        );
      } else {
        await showAlert(
          "error",
          t("servicePageActivation.upsell.alerts.error.saving.title"),
          t("servicePageActivation.upsell.alerts.error.saving.text")
        );
      }

      console.error("Error saving Upsell settings:", error);
    }
  };

  const handlePay = async () => {
    const result = await showAlert(
      "info",
      "ميزة مدفوعة",
      "هذه الميزة متاحة فقط للمشتركين. يرجى شراء الاشتراك للوصول إلى هذه الميزة.",
      true,
      "شراء الاشتراك"
    );

    if (result.isConfirmed) {
      window.location.href = "/plan";
    }
  };

  // Statistics data for upsell
  const upsellStats = [
    {
      title: t("servicePageActivation.upsell.stats.averageOrderValue.title"),
      value: "15-25%",
      description: t("servicePageActivation.upsell.stats.averageOrderValue.description"),
      icon: <DollarSign className="text-green-500" size={20} />,
    },
    {
      title: t("servicePageActivation.upsell.stats.offerAcceptanceRate.title"),
      value: "10-30%",
      description: t("servicePageActivation.upsell.stats.offerAcceptanceRate.description"),
      icon: <Check className="text-blue-500" size={20} />,
    },
    {
      title: t("servicePageActivation.upsell.stats.totalSalesIncrease.title"),
      value: "5-20%",
      description: t("servicePageActivation.upsell.stats.totalSalesIncrease.description"),
      icon: <TrendingUp className="text-[#9e68ba]" size={20} />,
    },
  ];

  // If feature is locked, show lock screen
  if (store.speakpage === false) {
    return (
      <div className="min-h-[400px] h-fit p-6"  >
        <div className="bg-white dark:!bg-[#181819] dark:!border-[#3c3a3d] rounded-xl shadow-sm p-6 border border-[#fbf4ff]">
          <div className="mb-6">
            <h3 className="text-xl font-bold text-[#9e68ba] mb-2 flex items-center">
              <TrendingUp className="ml-2" size={20} />
              {t("servicePageActivation.upsell.title")}
            </h3>
            <p className="text-gray-600 dark:!text-gray-400">
              {t("servicePageActivation.upsell.description")}
            </p>
          </div>

          {/* Service Status Indicator */}
          <div
            className={`mb-4 p-3 rounded-lg border ${isUpsellActive
              ? "bg-white border-gray-200 dark:!bg-[#181819] dark:!border-[#3c3a3d]"
              : "bg-white border-gray-200 dark:!bg-[#181819] dark:!border-[#3c3a3d]"
              }`}
          >
            <div className="flex items-center gap-x-2">
              <div
                className={`w-3 h-3 rounded-full mr-2 ${isUpsellActive ? "bg-green-500" : "bg-gray-500"
                  }`}
              ></div>
              <span
                className={`text-sm font-medium ${isUpsellActive ? "text-green-700 dark:!text-green-300" : "text-gray-700 dark:!text-gray-400"
                  }`}
              >
                {isUpsellActive
                  ? t("servicePageActivation.upsell.status.active")
                  : t("servicePageActivation.upsell.status.inactive")}
              </span>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Main Toggle */}
            <div>
              <div className="flex justify-between items-center mb-4">
                <label className="block text-sm font-medium text-[#9e68ba]">
                  {t("servicePageActivation.upsell.toggle.label")}
                </label>
                <div
                  className={`px-2 py-1 rounded-full text-xs font-medium ${data.Upsell
                      ? "bg-green-100 text-green-800 dark:!bg-green-900 dark:!text-green-300"
                      : "bg-gray-100 text-gray-800 dark:!bg-[#3c3a3d] dark:!text-gray-400"
                    }`}
                >
                  {data.Upsell
                    ? t("servicePageActivation.upsell.toggle.active")
                    : t("servicePageActivation.upsell.toggle.inactive")}
                </div>
              </div>

              <div
                className={`p-4 rounded-lg border transition-colors cursor-pointer flex items-center ${data.Upsell
                    ? "bg-[#fcf6ff] border-purple-200 dark:!bg-[#181819] dark:!border-[#3c3a3d]"
                    : "bg-white border-gray-200 hover:bg-gray-50 dark:!bg-[#181819] dark:!border-[#3c3a3d] dark:hover:!bg-[#222223]"
                  }`}
                onClick={handleDChange}
              >
                <div className="relative inline-block w-12 ml-3 align-middle select-none">
                  <input
                    type="checkbox"
                    checked={data.Upsell}
                    onChange={() => { }}
                    className="hidden"
                    id="toggle"
                  />
                  <label
                    htmlFor="toggle"
                    className={`block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer ${data.Upsell ? "bg-purple-400" : ""
                      }`}
                  >
                    <span
                      className={`block h-6 w-6 rounded-full bg-white shadow transform transition-transform duration-200 ease-in ${data.Upsell ? "rtl:-translate-x-6 ltr:translate-x-6" : "translate-x-0"
                        }`}
                    />
                  </label>
                </div>

                <div>
                  <div className="flex items-center">
                    {data.Upsell ? (
                      <TrendingUp size={18} className="ml-2 text-[#9e68ba]" />
                    ) : (
                      <X size={18} className="ml-2 text-gray-500 dark:!text-gray-400" />
                    )}
                    <p className="font-medium">
                      {data.Upsell
                        ? t("servicePageActivation.upsell.toggle.enabledTitle")
                        : t("servicePageActivation.upsell.toggle.disabledTitle")}
                    </p>
                  </div>
                  <p className="text-sm text-gray-500 dark:!text-gray-400 mt-1">
                    {data.Upsell
                      ? t("servicePageActivation.upsell.toggle.enabledDescription")
                      : t("servicePageActivation.upsell.toggle.disabledDescription")}
                  </p>
                </div>
              </div>
            </div>

            {/* Upsell Stats */}
            {data.Upsell && (
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {upsellStats.map((stat, index) => (
                  <div
                    key={index}
                    className="rounded-lg p-4 border border-gray-200 dark:!border-[#3c3a3d] bg-white dark:!bg-[#181819] shadow-sm"
                  >
                    <div className="flex items-center mb-2">
                      {stat.icon}
                      <h4 className="font-medium text-gray-800 dark:!text-gray-300 mr-2">
                        {stat.title}
                      </h4>
                    </div>
                    <div className="text-2xl font-bold text-[#9e68ba] mb-1">
                      {stat.value}
                    </div>
                    <p className="text-sm text-gray-600 dark:!text-gray-400">
                      {stat.description}
                    </p>
                  </div>
                ))}
              </div>
            )}

            {/* Upsell Strategies */}
            {data.Upsell && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="rounded-lg p-4 border border-gray-200 dark:!border-[#3c3a3d] bg-white dark:!bg-[#181819]">
                  <div className="flex items-center text-green-700 dark:!text-green-300 mb-2">
                    <ShoppingBag size={18} className="ml-2" />
                    <h4 className="font-medium">
                      {t("servicePageActivation.upsell.strategies.complementary.title")}
                    </h4>
                  </div>
                  <p className="text-sm text-gray-700 dark:!text-gray-400">
                    {t("servicePageActivation.upsell.strategies.complementary.text")}
                  </p>
                </div>

                <div className="rounded-lg p-4 border border-gray-200 dark:!border-[#3c3a3d] bg-white dark:!bg-[#181819]">
                  <div className="flex items-center text-blue-700 dark:!text-blue-300 mb-2">
                    <Gift size={18} className="ml-2" />
                    <h4 className="font-medium">
                      {t("servicePageActivation.upsell.strategies.offers.title")}
                    </h4>
                  </div>
                  <p className="text-sm text-gray-700 dark:!text-gray-400">
                    {t("servicePageActivation.upsell.strategies.offers.text")}
                  </p>
                </div>
              </div>
            )}

            {/* Tips Section */}
            <div className="p-4 rounded-lg border border-blue-100 dark:!border-[#3c3a3d] bg-blue-50 dark:!bg-[#181819]">
              <h4 className="font-medium text-lg text-blue-800 dark:!text-blue-300 mb-2 flex items-center">
                <Info size={18} className="ml-2" />
                {t("servicePageActivation.upsell.tips.title")}
              </h4>
              <ul className="text-sm text-gray-700 dark:!text-gray-400 space-y-2 mr-5 list-disc">
                <li className="flex items-start">
                  <span className="ml-2 inline-block">
                    <ShoppingBag size={14} className="text-blue-600 mt-1" />
                  </span>
                  <span>{t("servicePageActivation.upsell.tips.list.0")}</span>
                </li>
                <li className="flex items-start">
                  <span className="ml-2 inline-block">
                    <DollarSign size={14} className="text-blue-600 mt-1" />
                  </span>
                  <span>{t("servicePageActivation.upsell.tips.list.1")}</span>
                </li>
                <li className="flex items-start">
                  <span className="ml-2 inline-block">
                    <Check size={14} className="text-blue-600 mt-1" />
                  </span>
                  <span>{t("servicePageActivation.upsell.tips.list.2")}</span>
                </li>
                <li className="flex items-start">
                  <span className="ml-2 inline-block">
                    <TrendingUp size={14} className="text-blue-600 mt-1" />
                  </span>
                  <span>{t("servicePageActivation.upsell.tips.list.3")}</span>
                </li>
                <li className="flex items-start">
                  <span className="ml-2 inline-block">
                    <ToggleRight size={14} className="text-blue-600 mt-1" />
                  </span>
                  <span>{t("servicePageActivation.upsell.tips.list.4")}</span>
                </li>
              </ul>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={loading}
              className={`px-6 py-3 ${data.Upsell !== isUpsellActive
                  ? data.Upsell
                    ? "bg-[#9b59bf] hover:bg-[#814a9f]"
                    : "bg-red-500 hover:bg-red-600"
                  : "bg-gray-400"
                } text-white rounded-lg transition-colors flex items-center justify-center ${loading ? "opacity-70 cursor-not-allowed" : ""
                }`}
            >
              {loading ? (
                <>
                  <RefreshCw className="animate-spin ml-2" size={18} />
                  {data.Upsell
                    ? t("servicePageActivation.upsell.button.enabling")
                    : t("servicePageActivation.upsell.button.disabling")}
                </>
              ) : (
                <>
                  {data.Upsell !== isUpsellActive ? (
                    data.Upsell ? (
                      <>
                        <Check className="ml-2" size={18} />
                        {t("servicePageActivation.upsell.button.enable")}
                      </>
                    ) : (
                      <>
                        <X className="ml-2" size={18} />
                        {t("servicePageActivation.upsell.button.disable")}
                      </>
                    )
                  ) : (
                    <>
                      <Info className="ml-2" size={18} />
                      {t("servicePageActivation.upsell.button.noChange")}
                    </>
                  )}
                </>
              )}
            </button>
          </form>

        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[400px] h-fit p-6"  >
      <div className="bg-white dark:!bg-[#181819] dark:!border-[#3c3a3d] rounded-xl shadow-sm p-6 border border-[#fbf4ff]">
        <div className="mb-6">
          <h3 className="text-xl font-bold text-[#9e68ba] mb-2 flex items-center">
            <TrendingUp className="ml-2" size={20} />
            {t("servicePageActivation.upsell.title")}
          </h3>
          <p className="text-gray-600 dark:!text-gray-400">
            {t("servicePageActivation.upsell.description")}
          </p>
        </div>

        {/* Service Status Indicator */}
        <div
          className={`mb-4 p-3 rounded-lg border ${isUpsellActive
            ? "border-green-200 bg-white dark:!bg-[#181819] dark:!border-[#3c3a3d]"
            : "border-gray-200 bg-white dark:!bg-[#181819] dark:!border-[#3c3a3d]"
            }`}
        >
          <div className="flex items-center gap-x-2">
            <div
              className={`w-3 h-3 rounded-full mr-2 ${isUpsellActive ? "bg-green-500" : "bg-gray-400"
                }`}
            ></div>
            <span
              className={`text-sm font-medium ${isUpsellActive ? "text-green-700 dark:!text-green-400" : "text-gray-700 dark:!text-gray-400"
                }`}
            >
              {isUpsellActive
                ? t("servicePageActivation.upsell.status.active")
                : t("servicePageActivation.upsell.status.inactive")}
            </span>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Main Toggle */}
          <div>
            <div className="flex justify-between items-center mb-4">
              <label className="block text-sm font-medium text-[#9e68ba] dark:!text-white">
                {t("servicePageActivation.upsell.toggle.label")}
              </label>
              <div
                className={`px-2 py-1 rounded-full text-xs font-medium dark:!text-white ${data.Upsell
                  ? "bg-[#fcf6ff] text-[#9e68ba] dark:!bg-[#2a2a2b] dark:!text-white"
                  : "bg-gray-100 text-gray-800 dark:!bg-[#2a2a2b] dark:!text-white"
                  }`}
              >
                {data.Upsell
                  ? t("servicePageActivation.upsell.toggle.active")
                  : t("servicePageActivation.upsell.toggle.inactive")}
              </div>
            </div>
            <div
              className={`p-4 rounded-lg border transition-colors cursor-pointer flex items-center ${data.Upsell
                ? "bg-[#fcf6ff] border-purple-200 dark:!bg-[#181819] dark:!border-[#3c3a3d]"
                : "bg-white border-gray-200 hover:bg-gray-50 dark:!bg-[#181819] dark:!border-[#3c3a3d]"
                }`}
              onClick={handleDChange}
            >
              <div className="relative inline-block w-12 ml-3 align-middle select-none">
                <input
                  type="checkbox"
                  checked={data.Upsell}
                  onChange={() => { }}
                  className="hidden"
                  id="toggle"
                />
                <label
                  htmlFor="toggle"
                  className={`block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer ${data.Upsell ? "bg-purple-400" : ""
                    }`}
                >
                  <span
                    className={`block h-6 w-6 rounded-full bg-white shadow transform transition-transform duration-200 ease-in ${data.Upsell ? "rtl:-translate-x-6 ltr:translate-x-6" : "translate-x-0"
                      }`}
                  />
                </label>
              </div>
              <div>
                <div className="flex items-center">
                  {data.Upsell ? (
                    <TrendingUp size={18} className="ml-2 text-[#9e68ba]" />
                  ) : (
                    <X size={18} className="ml-2 text-gray-500" />
                  )}
                  <p className="font-medium dark:!text-gray-300">
                    {data.Upsell
                      ? t("servicePageActivation.upsell.toggle.enabledTitle")
                      : t("servicePageActivation.upsell.toggle.disabledTitle")}
                  </p>
                </div>
                <p className="text-sm text-gray-500 mt-1 dark:!text-gray-400">
                  {data.Upsell
                    ? t("servicePageActivation.upsell.toggle.enabledDescription")
                    : t("servicePageActivation.upsell.toggle.disabledDescription")}
                </p>
              </div>
            </div>
          </div>

          {/* Upsell Stats - visible when feature is enabled */}
          {data.Upsell && (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {upsellStats.map((stat, index) => (
                <div
                  key={index}
                  className="bg-white rounded-lg p-4 border border-gray-200 shadow-sm dark:!bg-[#181819] dark:!border-[#3c3a3d]"
                >
                  <div className="flex items-center mb-2">
                    {stat.icon}
                    <h4 className="font-medium text-gray-800 mr-2 dark:!text-gray-300">
                      {stat.title}
                    </h4>
                  </div>
                  <div className="text-2xl font-bold text-[#9e68ba] mb-1">
                    {stat.value}
                  </div>
                  <p className="text-sm text-gray-600 dark:!text-gray-400">
                    {stat.description}
                  </p>
                </div>
              ))}
            </div>
          )}

          {/* Upsell Strategy Section */}
          {data.Upsell && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="rounded-lg p-4 border border-gray-200 dark:!bg-[#181819] dark:!border-[#3c3a3d]">
                <div className="flex items-center text-gray-700 dark:!text-gray-300 mb-2">
                  <ShoppingBag size={18} className="ml-2 text-[#9e68ba]" />
                  <h4 className="font-medium dark:!text-gray-300">
                    {t(
                      "servicePageActivation.upsell.strategies.complementary.title"
                    )}
                  </h4>
                </div>
                <p className="text-sm text-gray-700 dark:!text-gray-400">
                  {t("servicePageActivation.upsell.strategies.complementary.text")}
                </p>
              </div>

              <div className="rounded-lg p-4 border border-gray-200 dark:!bg-[#181819] dark:!border-[#3c3a3d]">
                <div className="flex items-center text-gray-700 dark:!text-gray-300 mb-2">
                  <Gift size={18} className="ml-2 text-[#9e68ba]" />
                  <h4 className="font-medium dark:!text-gray-300">
                    {t("servicePageActivation.upsell.strategies.offers.title")}
                  </h4>
                </div>
                <p className="text-sm text-gray-700 dark:!text-gray-400">
                  {t("servicePageActivation.upsell.strategies.offers.text")}
                </p>
              </div>
            </div>
          )}

          {/* Tips Section */}
          <div className="p-4 rounded-lg border border-gray-200 dark:!bg-[#181819] dark:!border-[#3c3a3d]">
            <h4 className="font-medium text-lg text-[#9e68ba] mb-2 flex items-center">
              <Info size={18} className="ml-2" />
              {t("servicePageActivation.upsell.tips.title")}
            </h4>
            <ul className="text-sm text-gray-700 dark:!text-gray-400 space-y-2 mr-5 list-disc">
              <li className="flex items-start">
                <span className="ml-2 inline-block">
                  <ShoppingBag size={14} className="text-[#9e68ba] mt-1" />
                </span>
                <span>{t("servicePageActivation.upsell.tips.list.0")}</span>
              </li>
              <li className="flex items-start">
                <span className="ml-2 inline-block">
                  <DollarSign size={14} className="text-[#9e68ba] mt-1" />
                </span>
                <span>{t("servicePageActivation.upsell.tips.list.1")}</span>
              </li>
              <li className="flex items-start">
                <span className="ml-2 inline-block">
                  <Check size={14} className="text-[#9e68ba] mt-1" />
                </span>
                <span>{t("servicePageActivation.upsell.tips.list.2")}</span>
              </li>
              <li className="flex items-start">
                <span className="ml-2 inline-block">
                  <TrendingUp size={14} className="text-[#9e68ba] mt-1" />
                </span>
                <span>{t("servicePageActivation.upsell.tips.list.3")}</span>
              </li>
              <li className="flex items-start">
                <span className="ml-2 inline-block">
                  <ToggleRight size={14} className="text-[#9e68ba] mt-1" />
                </span>
                <span>{t("servicePageActivation.upsell.tips.list.4")}</span>
              </li>
            </ul>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            className={`px-6 py-3 ${data.Upsell !== isUpsellActive
              ? data.Upsell
                ? "bg-[#9b59bf] hover:bg-[#814a9f]"
                : "bg-red-500 hover:bg-red-600"
              : "bg-gray-400"
              } text-white rounded-lg transition-colors flex items-center justify-center ${loading ? "opacity-70 cursor-not-allowed" : ""
              }`}
          >
            {loading ? (
              <>
                <RefreshCw className="animate-spin ml-2" size={18} />
                {data.Upsell
                  ? t("servicePageActivation.upsell.button.enabling")
                  : t("servicePageActivation.upsell.button.disabling")}
              </>
            ) : (
              <>
                {data.Upsell !== isUpsellActive ? (
                  data.Upsell ? (
                    <>
                      <Check className="ml-2" size={18} />
                      {t("servicePageActivation.upsell.button.enable")}
                    </>
                  ) : (
                    <>
                      <X className="ml-2" size={18} />
                      {t("servicePageActivation.upsell.button.disable")}
                    </>
                  )
                ) : (
                  <>
                    <Info className="ml-2" size={18} />
                    {t("servicePageActivation.upsell.button.noChange")}
                  </>
                )}
              </>
            )}
          </button>
        </form>

      </div>
    </div>
  );
}
